import React, { Component } from 'react';
import {Auth} from 'aws-amplify';
import QRCode from 'qrcode';

class LoggedIn extends Component {

  state = {
    inputOldPassword: '',
    inputNewPassword1: '',
    inputNewPassword2: '',
    username: '',
    changingPassword: false,
    changingMFA: false,
    MFASecret: '',
    inputMFACode: ''
  }

  componentDidMount() {
    Auth.currentAuthenticatedUser()
    .then(user => {
      this.setState({username: user.username});
    })
    .catch(err => {
      console.log(err);
    });
  }

  render() {

    const {
      username,
      changingPassword,
      changingMFA,
      inputOldPassword,
      inputNewPassword1,
      inputNewPassword2,
      inputMFACode,
      MFASecret
    } = this.state;

    const {
      handleLogOut,
      handleToggleChangePassword,
      handleToggleChangeMFA,
      updateInput,
      handleChangePassword,
      handleChangeMFA,
      handleAuthenticateMFA,
      handleRefreshMFA
    } = this;

    return (
      <div className="LoggedInPage">
        <h1>Logged in as{username ? `: ${username}` : '...'} </h1>
        <button onClick={handleLogOut}>Log Out</button>
        <br/>
        <button onClick={handleToggleChangePassword}>{changingPassword ? 'Cancel' : 'Change Password'}</button>
        <br/>
        {/* <button onClick={handleToggleChangeMFA}>{changingMFA ? 'Cancel' : 'Change MFA Device'}</button> */}
        <button onClick={handleToggleChangeMFA}>{changingMFA ? 'Cancel' : 'Change MFA Device'}</button>

        {
          changingPassword &&
          <React.Fragment>
            <label htmlFor="inputOldPassword">Old Password</label>
            <input id="inputOldPassword" value={inputOldPassword} onChange={updateInput} type="password"/>
            <label htmlFor="inputNewPassword1">New Password</label>
            <input id="inputNewPassword1" value={inputNewPassword1} onChange={updateInput} type="password"/>
            <label htmlFor="inputNewPassword2">Confirm New Password</label>
            <input id="inputNewPassword2" value={inputNewPassword2} onChange={updateInput} type="password"/>
            <button onClick={handleChangePassword}>Submit</button>
          </React.Fragment>
        }

        {changingMFA &&
        <React.Fragment>
          <canvas id="MFAQRCodeCanvas"></canvas>
          <p>Code: {MFASecret}</p>
          <label htmlFor="inputMFACode">MFA Code</label>
          <input id="inputMFACode" value={inputMFACode} onChange={updateInput}/>
          <button onClick={handleAuthenticateMFA}>Authenticate</button>
          <button onClick={handleChangeMFA}>Refresh</button>
        </React.Fragment>}

      </div>
    );

  }

  updateInput = e => {
    this.setState({[e.target.id]: e.target.value});
  }

  handleLogOut = () => {

    const {updateUserState, pushToLog} = this.props;

    Auth.signOut()
    .then(res => {
      updateUserState({challengeName: 'LOGGED_OUT'});
      pushToLog('Successfully logged out.');
    })
    .catch(err => {
      console.log(err);
    });

  }

  handleToggleChangePassword = () => {
    this.setState({changingPassword: !this.state.changingPassword});
  }

  handleToggleChangeMFA = () => {
    this.setState({changingMFA: !this.state.changingMFA}, () => {
      if (this.state.changingMFA) this.handleChangeMFA();
    });
  }

  handleChangePassword = () => {

    const {inputOldPassword, inputNewPassword1, inputNewPassword2} = this.state;
    const {pushToLog} = this.props;

    if (inputOldPassword === '') pushToLog('Password cannot be blank.');
    else if (inputNewPassword1 !== inputNewPassword2) pushToLog('New passwords must match.');
    else if (inputNewPassword1 === '') pushToLog('New password cannot be blank.');
    else if (inputNewPassword1.length < 8) pushToLog('New password must be at least 8 characters long.');
    else if (!/[0-9]/.test(inputNewPassword1)) pushToLog('New password must contain at least one number.');
    else if (!/[a-z]/.test(inputNewPassword1)) pushToLog('New password must contain at least one lower case letter.');
    else if (!/[A-Z]/.test(inputNewPassword1)) pushToLog('New password must contain at least one upper case letter.');
    else if (!/[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/.test(inputNewPassword1)) pushToLog('New password must contain at least one special character.');
    else {
      Auth.currentAuthenticatedUser()
      .then(user => {
        return Auth.changePassword(user, inputOldPassword, inputNewPassword1);
      })
      .then(res => {
        if (res === 'SUCCESS') {
          pushToLog('Password changed successfully.');
          this.setState({changingPassword: false});
        } else console.log(res);
      })
      .catch(err => {
        console.log(err);
      });
    };

  }

  handleChangeMFA = () => {

    Auth.currentAuthenticatedUser()
    .then(user => {
      // console.log(user);
      return Auth.setupTOTP(user);
    })
    .then(res => {
      console.log(res);
      this.setState({MFASecret: res});
      QRCode.toCanvas(document.getElementById('MFAQRCodeCanvas'), `otpauth://totp/Weaveability Basis Utilities:${this.state.username}?secret=${res}&issuer=Weaveability Basis Utilities`);
    });

  }

  handleAuthenticateMFA = () => {

    const {pushToLog, updateUserState} = this.props;

    const formattedMFACode = this.state.inputMFACode.replace(/ /g, '');

    if (formattedMFACode.length !== 6) pushToLog('MFA code must be exactly six characters long.');
    else if (/[^0-9]/.test(formattedMFACode)) pushToLog('MFA code must only contain numbers.');
    else {

      Auth.currentAuthenticatedUser()
      .then(user => {
        return Auth.verifyTotpToken(user, formattedMFACode);
      })
      .then(res => {

        this.setState({inputMFACode: '', changingMFA: false});
        pushToLog('MFA Device Set Up Successfully.');

      })
      .catch(err => {

        if (err.message === 'Invalid session for the user, session is expired.') {
          pushToLog('Your session expired. Please log in again.');
        } else if (err.message === 'Code mismatch and fail enable Software Token MFA') {
          pushToLog('Invalid MFA token.');
        } else {
          console.log(err);
        }

      });

    }
  }

}

export default LoggedIn;


// WEBPACK FOOTER //
// ./src/components/content/user/userComponents/loggedIn.js